import { boolean, index, jsonb, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { BriefStatus } from "../types";
export const briefs = pgTable("briefs", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    cadence: text("cadence").notNull().$type(),
    periodStart: timestamp("period_start", { withTimezone: true }).notNull(),
    periodEnd: timestamp("period_end", { withTimezone: true }).notNull(),
    executiveSnapshot: text("executive_snapshot"),
    sections: jsonb("sections").$type().notNull().default({
        keyChanges: [],
        risksAndAnomalies: [],
        opportunities: [],
        suggestedActions: [],
    }),
    metricSnapshots: jsonb("metric_snapshots").$type().notNull().default([]),
    signalIds: jsonb("signal_ids").$type().notNull().default([]),
    insightIds: jsonb("insight_ids").$type().notNull().default([]),
    actionIds: jsonb("action_ids").$type().notNull().default([]),
    status: text("status").notNull().$type().default(BriefStatus.GENERATING),
    isEmpty: boolean("is_empty").notNull().default(false),
    generatedAt: timestamp("generated_at", { withTimezone: true }),
    deliveredAt: timestamp("delivered_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    companyCreatedIdx: index("idx_briefs_company_created").on(table.companyId, table.createdAt),
    companyCadenceIdx: index("idx_briefs_company_cadence").on(table.companyId, table.cadence),
    periodIdx: index("idx_briefs_period").on(table.companyId, table.cadence, table.periodEnd),
}));
